import { render, staticRenderFns } from "./romanceInTheHouse.vue?vue&type=template&id=7af600eb"
import script from "./romanceInTheHouse.vue?vue&type=script&lang=js"
export * from "./romanceInTheHouse.vue?vue&type=script&lang=js"
import style0 from "./romanceInTheHouse.vue?vue&type=style&index=0&id=7af600eb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports